import { Immutable } from "immer";
import React from "react";

export const SrFootnote = (
    props: Immutable<{ text: string }>,
): React.JSX.Element => (
    <span className="ada-screenreader-only">{props.text}</span>
);
